import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse, Fade, Grow, Slide, Typography, Zoom } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
/**
 * This component will animate the array of strings passed as words.
 */
export var AnimatedText = function (_a) {
    var words = _a.words, animationType = _a.animationType, _b = _a.animationTimeout, animationTimeout = _b === void 0 ? 4000 : _b;
    var _c = useState(0), wordIndex = _c[0], setWordIndex = _c[1];
    var _d = useState(true), showSlide = _d[0], setSetShowSlide = _d[1];
    var indexInterval = useRef();
    var slideInterval = useRef();
    useEffect(function () {
        var setupTimeouts = function () {
            indexInterval.current = setTimeout(function () {
                setSetShowSlide(false);
                slideInterval.current = setTimeout(function () {
                    if (wordIndex + 1 === words.length) {
                        setWordIndex(0);
                    }
                    else {
                        setWordIndex(wordIndex + 1);
                    }
                    setSetShowSlide(true);
                }, animationTimeout - (animationTimeout - 1200));
            }, animationTimeout);
        };
        setupTimeouts();
        return function () {
            clearInterval(indexInterval.current);
            clearInterval(slideInterval.current);
        };
    }, [animationTimeout, wordIndex, words.length]);
    if (animationType === 'grow') {
        return (_jsx(Grow, __assign({ in: showSlide, timeout: { enter: 800, exit: 1200 } }, { children: _jsx(Typography, __assign({ variant: "inherit", component: "div", color: "hubYellow.main" }, { children: words[wordIndex] })) })));
    }
    if (animationType === 'zoom') {
        return (_jsx(Zoom, __assign({ in: showSlide, timeout: { enter: 800, exit: 1200 } }, { children: _jsx(Typography, __assign({ variant: "inherit", component: "div", color: "hubYellow.main" }, { children: words[wordIndex] })) })));
    }
    if (animationType === 'slide') {
        return (_jsx(Slide, __assign({ direction: "down", in: showSlide, timeout: { enter: 800, exit: 1200 } }, { children: _jsx(Typography, __assign({ variant: "inherit", component: "div", color: "hubYellow.main" }, { children: words[wordIndex] })) })));
    }
    if (animationType === 'fade') {
        return (_jsx(Fade, __assign({ in: showSlide, timeout: { enter: 800, exit: 1200 } }, { children: _jsx(Typography, __assign({ variant: "inherit", component: "div", color: "hubYellow.main" }, { children: words[wordIndex] })) })));
    }
    return (_jsx(Collapse, __assign({ orientation: "horizontal", in: showSlide, timeout: { enter: 800, exit: 1200 } }, { children: _jsx(Typography, __assign({ variant: "inherit", component: "div", color: "hubYellow.main", sx: { overflow: 'hidden', whiteSpace: 'nowrap' } }, { children: words[wordIndex] })) })));
};
